import { createContext } from 'react';
import { Stats } from '@/contexts/stats/types';

export const StatsContext = createContext<Stats>({} as Stats);
StatsContext.displayName = 'StatsButtons';
